import React, { useState, useEffect } from "react";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import useTable from "../../useTable";
import axios from "axios";
import { Toasts } from "../../toasts";
import { ActualizarUsuario } from "./modalUsuarioPro";
import { CambiarClave } from "../../comun/modalCambiarClave";
import { SearchInput } from "../../../ui/inputs/Input";
import { PrimaryButton, WarningButton } from "../../../ui/buttons/Button";

function TablaUsuarioPro(props) {
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [espiritu, setEspiritu] = useState(localStorage.getItem("espiritu"));
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const [activate, setActivate] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [persona, setPersona] = useState();
  const [usuarioH, setUsuarioH] = useState();
  const [idUsuario] = useState();
  const [mostrar2, setMostrar2] = useState(false);
  const [operacion, setOperacion] = useState();
  const permiso = JSON.parse(localStorage.getItem("accusuariopublicidad"));
  const [records, setRecords] = useState([]);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const [deshabilitado] = useState(false);
  const [configCome] = useState();

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const headCells = [
    {
      id: "idinmueble",
      label: "CODIGO",
      width: "10px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "numficha",
      label: "USUARIO",
      width: "70px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "nombrepropie",
      label: "NOMBRES",
      width: "250px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "dirinmueble",
      label: "OPCIONES",
      width: "250px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idusuario.includes(target.value) ||
              x.login.toLowerCase().includes(target.value.toLowerCase()) ||
              (x.nombres + " " + x.apellidos)
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const SelectDeudaC = (data) => {
    let endpoint = `${op.conexion}/api/inmueble/deudainmueble?idinmueble=${data.idinmueble}&fecha=${fechaSistema}&espiritu=${espiritu}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log("segunda consulta lista");

          var deu = [];
          var his = [];
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                multa: response.data[i].multa,
                recargo: response.data[i].recargodeu,
              });
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
              });
            }
          }
        } else {
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const renderizar = () => {
    setMostrar5(false);
    setPersona();
    setUsuarioH();
    seleccionarUsuarios();
  };

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    setEspiritu(obj.espiritu);
    seleccionarUsuarios();
  }, []);

  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };
  const seleccionarUsuarios = () => {
    setActivate(true);
    let endpoint = op.conexion + `/api/publicidad/modulouser`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            console.log(response.data);
            setRecords(response.data);

            setActivate(false);
          } else {
            setRecords([]);
          }
        }

        setActivate(false);
      })
      .catch((error) => {
        setActivate(false);
      });
    //selectUsu();
  };
  const gestionarUsuario = (index, op, per) => (event) => {
    event.preventDefault();
    setOperacion(op);
    if (per.toString() === "1") {
      if (op === 1) {
        setMostrar5(true);
      } else {
        setActivate(true);
        setPersona({
          cedula: index.cedula,
          nombres: index.nombres,
          apellidos: index.apellidos,
          correoe: index.correoe,
          tlf1: index.tlf1,
          tlf2: index.tlf2,
          fnacimiento: index.fnacimiento,
          nacionalidad: index.nacionalidad,
          sexo: index.sexo,
          direccion: index.direccion,
        });
        setUsuarioH(index);
        setMostrar5(true);
        setActivate(false);
      }
    } else {
      setToast({
        mostrar: true,
        mensaje:
          op === 1
            ? "No posee permiso para Registrar"
            : op === 2
            ? "No posee permiso para Editar"
            : op === 3
            ? "No posee permiso para Eliminar"
            : "No posee permiso para Consultar",
        titulo: "Alerta.",
      });
    }
  };
  const cerrarModalActualizar = () => {
    setUsuarioH();
    setPersona();
    setMostrar5(false);
  };
  const validarActuUsuario = () => {
    if (operacion === 4) {
      setUsuarioH();
      setMostrar5(false);
      return;
    }
    if (operacion === 1) {
    }
    setUsuarioH();
    setPersona();
    setMostrar5(false);
    window.location.href = "/usuariosHacienda";
  };

  const cambiarClave = () => {
    setMostrar2(true);
  };

  const handleCloseClave = () => {
    setMostrar2(false);
  };

  const exitHandler = () => {
    props.setTabla(0);
  };

  return (
    <div className="col-8 m-0 p-2 border rounded">
      <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Gestion de Usuarios</h3>
        <a onClick={exitHandler} className="text-light fw-bold fs-6 ">
          Salir <i className="fas fa-times ms-2"></i>
        </a>
      </header>
      <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
        <div className="col-4 m-0 p-0">
          <SearchInput className='search-input ' placeholder="Buscar" onChange={handleSearch} />
        </div>
        <div className="col-auto m-0 p-0 d-flex gap-2">
          <WarningButton
            icon="fa-key"
            disabled={
              permiso &&
              permiso.substring(1, 2) !== "1" &&
              permiso.substring(2, 3) !== "1"
            }
            onClick={cambiarClave}
          >
            Cambiar Clave
          </WarningButton>

          <PrimaryButton
            icon="fa-plus m-0"
            onClick={gestionarUsuario(
              "",
              1,
              permiso.toString().substring(1, 2)
            )}
            disabled={permiso.toString().substring(1, 2) !== "1"}
          />
        </div>
      </div>
      <div className="col-12 m-0 p-0">
        <TblContainer>
          <TblHead />

          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={item.idusuario} style={{ padding: "0" }}>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      //  width: "10px",
                    }}
                  >
                    {item.idusuario}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      //width: "70px",
                    }}
                  >
                    {item.login}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      //width: "250px",
                    }}
                  >
                    {item.nombres}
                  </td>

                  <td
                    align="center"
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "180px",
                      padding: 0,
                    }}
                  >
                    <button
                      onClick={gestionarUsuario(
                        item,
                        4,
                        permiso.toString().substring(0, 1)
                      )}
                      className={
                        permiso.toString().substring(0, 1) === "1"
                          ? "btn btn-sm btn-info rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fas fa-eye"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                      onClick={gestionarUsuario(
                        item,
                        2,
                        permiso.toString().substring(2, 3)
                      )}
                      className={
                        permiso.toString().substring(2, 3) === "1"
                          ? "btn btn-sm btn-warning rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fa fa-edit"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                      onClick={gestionarUsuario(
                        item,
                        3,
                        permiso.toString().substring(3, 4)
                      )}
                      className={
                        permiso.toString().substring(3, 4) === "1"
                          ? "btn btn-sm btn-danger rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fa fa-trash-alt"></i>{" "}
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />

      <ActualizarUsuario
        show={mostrar5} /* titulo={titulo1} */ /* mensaje={msg1} */
        onHideCancela={cerrarModalActualizar}
        onHideAcepta={validarActuUsuario}
        usuario={usuarioH}
        datospersonales={persona}
        deshabilitado={deshabilitado ? deshabilitado : undefined}
        ingresa={0}
        declaweb={configCome ? configCome[0].declaweb.toString() : "false"}
        idusuario={idUsuario}
        operacion={operacion}
        render={renderizar}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={activate} inverted></Dimmer>
      <CambiarClave show={mostrar2} onHide={handleCloseClave} />
    </div>
  );
}

export default TablaUsuarioPro;
